import XLSX from 'xlsx'
import moment from "moment"
import { VUEX_SNACKBAR_SHOW } from '@/store/constants/snackbar'

let exportToExcel = {
    isLoadingData:false,
    type:'',
    t:null,

    export: function (type,t) {
        if (exportToExcel.isLoadingData===false) {
            //set variables
            exportToExcel.isLoadingData = true
            exportToExcel.type = type
            exportToExcel.t = t

            //dispatch based on type
            switch (exportToExcel.type) {
                case "jobs":
                case "requests":
                    exportToExcel.t.$store.dispatch('VUEX_JOBS_GET_REQUEST_FOR_EXCEL', {})
                    break
            }
        }
    },
    finish: function (payload) {
        //file name

        let nowDT = moment().format('MMDDYYYY-hhmmssa')
        let fileName = exportToExcel.type + "-" + nowDT + ".xlsx"

        //columns
        let columns = []
        switch (exportToExcel.type) {
            case "jobs":
                columns = [
                    {text: "Name", value: 'name'},
                    {text: "Job #", value: 'job_number'},
                    {text: "Department", value: 'department', formatting:'jobEnum',jobEnumType:'jobDepartments'},
                    {text: "International Department", value: 'international_subdepartment', formatting:'jobEnum',jobEnumType:'jobInternationalSubdepartments'},
                    {text: "Type", value: 'type', formatting:'jobEnum',jobEnumType:'jobTypes'},
                    {text: "Status", value: 'status', formatting:'jobEnum',jobEnumType:'jobStatuses'},
                    {text: "Progress", value: 'progress', formatting:'jobEnum',jobEnumType:'jobProgresses'},
                    {text: "Progress Note", value: 'progress_note', formatting:'jobEnum',jobEnumType:'jobProgressNotes'},
                    {text: "Date Submit", value: 'date_submitted',formatting:'datetime'},
                    {text: "Date Approved", value: 'date_approved',formatting:'datetime'},
                    {text: "Date Premedia", value: 'date_premedia',formatting:'date'},
                    {text: "Date First Comp", value: 'date_first_comp',formatting:'date'},
                    {text: "Date Release", value: 'date_release',formatting:'date'},
                    {text: "Date Delivery", value: 'date_delivery',formatting:'date'},
                    {text: "Date Extended Delivery", value: 'date_extended_delivery',formatting:'date'},

                    {text: "Priority", value: 'priority', formatting:'jobEnum',jobEnumType:'jobPriorities'},
                    {text: "Priority Note", value: 'priority_note'},
                    {text: "Priority Requested Delivery Date", value: 'priority_requested_delivery_date',formatting:'date'},
                    {text: "Priority First Comp Date", value: 'priority_requested_first_comp_date',formatting:'date'},
                    {text: "Priority Supervisor", value: 'priority_supervisor_name'},

                    {text: "Code", value: 'code', formatting:'jobEnum',jobEnumType:'jobCodes'},
                    {text: "Creative Round", value: 'creative_round', formatting:'jobEnum',jobEnumType:'jobCreativeRounds'},
                    {text: "Approver", value: 'approver',formatting:'user'},
                    {text: "Requestor", value: 'requestor',formatting:'user'},
                    {text: "Responsible", value: 'responsible',formatting:'user'},
                    {text: "Viewed Status", value: 'viewed_status',showNull:true},
                    {text: "Is 24 Rush?", value: 'is_24_hour_rush',showNull:true},
                    {text: "Is Archived?", value: 'is_archived',showNull:true},
                    {text: "Is Draft?", value: 'is_draft',showNull:true},
                    //{text: "Flag", value: 'flag'},
                    {text: "ID", value: 'id'},
                    {text: "Date Created", value: 'created_at',formatting:'datetime'},
                    {text: "Date Updated", value: 'updated_at',formatting:'datetime'},
                ]
                break
            case "requests":
                columns = [
                    {text: "Name", value: 'name'},
                    {text: "Job #", value: 'job_number'},
                    {text: "Department", value: 'department', formatting:'jobEnum',jobEnumType:'jobDepartments'},
                    {text: "International Department", value: 'international_subdepartment', formatting:'jobEnum',jobEnumType:'jobInternationalSubdepartments'},
                    {text: "Type", value: 'type', formatting:'jobEnum',jobEnumType:'jobTypes'},
                    {text: "Status", value: 'status', formatting:'jobEnum',jobEnumType:'jobStatuses'},

                    {text: "Date Submit", value: 'date_submitted',formatting:'datetime'},

                    {text: "Priority", value: 'priority', formatting:'jobEnum',jobEnumType:'jobPriorities'},
                    {text: "Priority Note", value: 'priority_note'},
                    {text: "Priority Requested Delivery Date", value: 'priority_requested_delivery_date',formatting:'date'},
                    {text: "Priority First Comp Date", value: 'priority_requested_first_comp_date',formatting:'date'},
                    {text: "Priority Supervisor", value: 'priority_supervisor_name'},

                    {text: "Requestor", value: 'requestor',formatting:'user'},
                    {text: "Viewed Status", value: 'viewed_status',showNull:true},
                    {text: "Is 24 Rush?", value: 'is_24_hour_rush',showNull:true},
                    {text: "Is Archived?", value: 'is_archived',showNull:true},
                    {text: "Is Draft?", value: 'is_draft',showNull:true},

                    {text: "ID", value: 'id'},
                    {text: "Date Created", value: 'created_at',formatting:'datetime'},
                    {text: "Date Updated", value: 'updated_at',formatting:'datetime'},
                ]
                break
        }

        //SET HEADERS AND DATA INTO results
        let results = []

        //PARSE COLUMN HEADERS
        let temparr = []
        for (let ii = 0; ii < columns.length; ii++) {
            let val = columns[ii].text
            if (val) {
                temparr.push(val)
            } else {
                temparr.push('')
            }
        }
        results.push(temparr)

        //PARSE DATA
        for (let i=0;i<payload.data.length;i++) {
            let obj = payload.data[i]
            let temparr = []
            let valNew = null
            for (let ii = 0; ii < columns.length; ii++) {
                let val = obj[columns[ii].value]

                //format value
                if (val && columns[ii].formatting) {
                    switch (columns[ii].formatting) {
                        case "datetime":
                            val = moment(val).format('MM/DD/YYYY hh:mm A')
                            break
                        case "date":
                            val = moment(val).format('MM/DD/YYYY')
                            break
                        case "user":
                            if (val.name) {
                                val = val.name
                            }
                            break
                        case "jobEnum":
                            val = exportToExcel.t.$store.getters.getJobEnumItemValue(columns[ii].jobEnumType, val, 'name')
                            break

                    }
                }

                //push value or null - sometimes you want to pass through a null (in the case of FALSE being a legit value)
                if (val || columns[ii].showNull ) {
                    temparr.push(val)
                } else {
                    temparr.push('')
                }
            }
            //add to results
            results.push(temparr)
        }

        //create spreadsheet
        let wb = XLSX.utils.book_new();
        let ws = XLSX.utils.aoa_to_sheet(results);
        XLSX.utils.book_append_sheet(wb, ws, 'Data');
        XLSX.writeFile(wb, fileName);

        //finish messaging
        exportToExcel.success()

    },

    //success final messaging
    success: function (messageAddon) {
        //messageAddon
        if (!messageAddon) {
            messageAddon=''
        }
        //SNACK
        exportToExcel.t.$store.dispatch(VUEX_SNACKBAR_SHOW, {
            description_text: "Excel File Success! "+messageAddon,
            button_text: "",
            timeout: 3000,
            button_dispatch: "",
            button_dispatch_payload: {},
        })

        exportToExcel.isLoadingData=false

    },

    //error final messaging
    fail: function (messageAddon) {
        //messageAddon
        if (!messageAddon) {
            messageAddon=''
        }
        //SNACK
        exportToExcel.t.$store.dispatch(VUEX_SNACKBAR_SHOW, {
            description_text: "Excel File Error: "+messageAddon,
            button_text: "",
            timeout: 3000,
            button_dispatch: "",
            button_dispatch_payload: {},
        })

        exportToExcel.isLoadingData=false
    }
}

export default exportToExcel